"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ContextualMenuItem_base_1 = require("./ContextualMenuItem.base");
var ContextualMenu_classNames_1 = require("./ContextualMenu.classNames");
/**
 * ContextualMenuItem description
 */
exports.ContextualMenuItem = Utilities_1.styled(ContextualMenuItem_base_1.ContextualMenuItemBase, ContextualMenu_classNames_1.getItemStyles, undefined, { scope: 'ContextualMenuItem' });
//# sourceMappingURL=ContextualMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ContextualMenu/ContextualMenuItem.js
// module id = 703
// module chunks = 0